import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import $ from "jquery";
import "./TopNavBar.css";
import "./TopNavBarPopUp.css";
import { post } from "../../app/shared/http";
import Dropdown from "react-bootstrap/Dropdown";
import { useMediaQuery } from "react-responsive";
import { FaUserAlt, FaBars } from "react-icons/fa";
import { Modal, Navbar, Nav } from "react-bootstrap";
import { handleException } from "../../app/util/util";
import { DropdownSubmenu } from "react-bootstrap-submenu";
import DropdownButton from "react-bootstrap/DropdownButton";
import NotificationBar from "../HeaderNavBar/NotificationBar";
import { AiFillCaretDown, AiFillCaretRight } from "react-icons/ai";
import logo from "./CC_Branding_New.png";
export default function TopNavBar(props) {
  let history = useHistory();
  const [key, setKey] = useState(props.pageName);
  const cqProfQuizConcPopUpPhoneInputRef = useRef(null);
  const isTAUser = localStorage.getItem("cqassistantFlag");
  const userVO = JSON.parse(localStorage.getItem("userVO"));

  // console.log(props, "props", userVO, localStorage.getItem('userVO'), "localStorage.getItem('userVO')");

  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1024px)" });
  const phoneRegex =
    /^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$/i;
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-device-width: 1224px)",
  });
  const isTabletOrMobileDevice = useMediaQuery({
    query: "(max-device-width: 1024px)",
  });
  const emailRegex =
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [redeemCode, setRedeemCode] = useState("");
  const [charitDown, setCharitDown] = useState(false);
  const [phoneErrMsg, setPhoneErrorMsg] = useState("");
  const [emailErroMsg, setEmailErrorMsg] = useState("");
  const [redeemCodeErr, setRedeemCodeErr] = useState("");
  const [redeemAccesCode, setRedeemAccesCode] = useState(false);
  const [showConFormPopUp, setShowConFormPopUp] = useState(false);
  const [showConThanksPopUp, setShowConThanksPopUp] = useState(false);
  const [isShowTutorialPopup, setIsShowTutorialPopup] = useState(false);
  const [showTutorialPopup, setShowTutorialPopup] = useState({
    popupHeading: "",
    popupDescr: "",
    popupVideoUrl: "",
  });
  const productsSubmenuButtonId = "products-submenu-button";
  const productsSubmenuId = "products-submenu";

  // fixed navigation through tab a11y_issue
  // react-overlays closes the menu on Tab; stop that except when focus really leaves.
  const handleDropdownTabKey = (event) => {
    if (event.key !== "Tab") return;
    const focusable = Array.from(
      event.currentTarget.querySelectorAll(
        'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])',
      ),
    ).filter((el) => el.getClientRects().length > 0);
    if (focusable.length === 0) return;
    const edge = event.shiftKey ? focusable[0] : focusable[focusable.length - 1];
    if (event.target === edge) return;
    event.stopPropagation();
  };

  useEffect(() => {
    showConFormPopUp && cqProfQuizConcPopUpPhoneInputRef.current.focus();
  }, [showConFormPopUp]);

  const handleLogOut = () => {
    var reqData = {
      bookVO: {
        bookId: null,
        pageNumber: null,
      },
    };
    post("/manageUserService/logout", reqData, "ENV", "LOGOUT_USER")
      .then((response) => response.json())
      .then((data) => {
        if (data) {
          if (data.status === "false" && data.wkErrorCode) {
            handleException(data);
          } else if (data.status === "true") {
            localStorage.setItem("userVO", null);
            localStorage.clear();
            localStorage.clear();
            history.push("/logout");
          }
        }
      })
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  };
  const gotoLogin = () => {
    window.location.replace(`${window.location.origin}/login`);
  };
  const handleShowTutorialPopup = (videoType) => {
    setIsShowTutorialPopup(true);
    if (userVO && userVO?.userRole === "Student") {
      switch (videoType) {
        case "ConnectedQuiz":
          setShowTutorialPopup({
            popupHeading: "Connected Quizzing Tutorial",
            popupDescr:
              "Watch the video below to familiarize yourself with the Connected Quizzing features.",
            popupVideoUrl:
              "https://player.vimeo.com/video/763524348?h=f7683cb52a&badge=0&autopause=0&player_id=0&app_id=58479",
          });
          break;
        case "PracticePerfect":
          setShowTutorialPopup({
            popupHeading: "PracticePerfect Tutorial",
            popupDescr: `Watch the video below to familiarize yourself with the features on PracticePerfect,
                        including the videos, quizzes, and progress dashboards.`,
            popupVideoUrl:
              "https://player.vimeo.com/video/765752778?h=f7683cb52a&badge=0&autopause=0&player_id=0&app_id=58479",
          });
          break;
        default:
          setShowTutorialPopup({
            popupHeading: "Casebook Connect Tutorial",
            popupDescr: `Whether you're new around here or returning for your current semester, we're happy to share the latest
                        features on Casebook Connect. Watch the video below to familiarize yourself with the platform.`,
            popupVideoUrl:
              "https://player.vimeo.com/video/765743286?h=f7683cb52a&badge=0&autopause=0&player_id=0&app_id=58479",
          });
          break;
      }
    } else if (userVO && userVO?.userRole === "Professor") {
      setShowTutorialPopup({
        popupHeading: "Casebook Connect Professor Tutorial",
        popupDescr: `Whether you're new around here or returning for your current semester, we're happy to share the latest
                features on Casebook Connect. Watch the video below to familiarize yourself with the platform.`,
        popupVideoUrl:
          "https://player.vimeo.com/video/765743506?h=f7683cb52a&badge=0&autopause=0&player_id=0&app_id=58479",
      });
    }
  };
  const handleAccessCodeKeyPress = (e) => {
    if (e.key === "Enter") {
      handleRedeemAccessCode();
    }
  };
  const handleHideRedeemAccessCode = () => {
    setRedeemCode("");
    setRedeemCodeErr("");
    setRedeemAccesCode(false);
  };
  const handleRedeemAccessCode = () => {
    if (redeemCode && redeemCode.trim().length > 0) {
      let reqData = { bookVO: { bookAccessCode: redeemCode } };
      post("/manageBookService/saveBookInBookshelf", reqData, "ENV")
        .then((response) => response.json())
        .then((data) => {
          if (data.status === "false" && data.wkErrorCode) {
            let wkErrMsg = "";
            if (
              data.wkErrorCode ===
              "bus.exception.user.already.have.all.books.with.life.time.access"
            ) {
              wkErrMsg =
                "Error: You already have lifetime access to this product.";
            } else if (
              data.wkErrorCode ===
              "bus.exception.you.have.longer.validity.period.than.the.used.access.code"
            ) {
              wkErrMsg =
                "Error: Code cannot be redeemed because it expires before current product expiration date.";
            } else if (
              data.wkErrorCode === "bus.exception.accesscode.has.expired"
            ) {
              wkErrMsg =
                "Error: This access code has already expired and cannot be redeemed.";
            } else if (
              data.wkErrorCode ===
              "bus.exception.you.already.have.lifetime.access.to.this.product"
            ) {
              wkErrMsg =
                "Error: You already have lifetime access to this product.";
            } else if (
              data.wkErrorCode ===
              "bus.exception.only.student.can.redeem.cq.code"
            ) {
              wkErrMsg =
                "Error: It looks like you're trying to redeem a student access code with" +
                " a professor account. To get set up with Connected Quizzing, contact the Quiz Concierge at" +
                " <a href='mailto:concierge@aspenpublishing.com'>concierge@aspenpublishing.com</a>.";
            } else if (
              data.wkErrorCode ===
                "bus.exception.access.code.already.been.used" ||
              data.wkErrorCode ===
                "bus.exception.collection.access.code.has.already.been.used"
            ) {
              wkErrMsg =
                "Error: You have already redeemed this access code. Please try a different code.";
            } else if (
              data.wkErrorCode === "bus.exception.accessCode.is.null" ||
              data.wkErrorCode === "bus.exception.invalid.accesscode"
            ) {
              wkErrMsg =
                "Error: This is an Invalid access code. Please try a different code.";
            } else if (
              data.wkErrorCode ===
                "bus.exception.book.already.availded.by.user" ||
              data.wkErrorCode ===
                "bus.exception.book.already.availded.by.loginuser"
            ) {
              wkErrMsg = "Error: You already have access to this book.";
            } else if (
              data.wkErrorCode ===
                "bus.exception.product.already.availded.by.loginuser" ||
              data.wkErrorCode === "bus.exception.already.have.a.active.product"
            ) {
              wkErrMsg = "Error: You already have access to this product.";
            } else {
              handleException(data);
            }
            setRedeemCodeErr(wkErrMsg);
          } else if (data.status === "true" && data.bookVOList) {
            data.bookVOList = Array.isArray(data.bookVOList)
              ? data.bookVOList
              : [data.bookVOList];
            handleHideRedeemAccessCode();
            history.push("/myDashboard");
            handleShowTutorialPopup(data.bookVOList[0].bookType);
          }
        })
        .catch((error) => {
          console.error(
            "There has been a problem with your fetch operation:",
            error,
          );
        });
    }
  };
  const handleHideContactMe = () => {
    setShowConFormPopUp(false);
    setPhone("");
    setEmail("");
    setMessage("");
    setPhoneErrorMsg("");
    setEmailErrorMsg("");
  };
  const handleContactMe = () => {
    var phoneValid = false,
      emailValid = false;
    if (phone === "") {
      setPhoneErrorMsg("Error: Enter a phone number");
    }
    if (email === "") {
      setEmailErrorMsg("Error: Enter an email address.");
    }
    if (email) {
      if (emailRegex.test(email)) {
        emailValid = true;
        setEmailErrorMsg("");
      } else {
        emailValid = false;
        setEmailErrorMsg("Please enter a valid email address.");
      }
    }
    if (phone) {
      if (phoneRegex.test(phone)) {
        phoneValid = true;
        setPhoneErrorMsg("");
      } else {
        phoneValid = false;
        setPhoneErrorMsg("Please enter a valid phone number.");
      }
    }
    if (emailValid === true && phoneValid == true) {
      handleSubmitConcierge();
      handleHideContactMe();
      setShowConThanksPopUp(true);
    }
  };
  const handleSubmitConcierge = () => {
    var reqData = {
      userProfVO: {
        email: email,
        phoneNum: phone,
        message: message,
        conciergeMessages: [],
      },
    };
    post("/manageCQ/contactMeNotify", reqData, "ENV")
      .then((response) => response.json())
      .then((data) => {
        if (data && data.status === "false" && data.wkErrorCode) {
          handleException(data);
        }
      })
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  };
  const handleOnBlurEvent = () => {
    let subChildDropDownDiv = document.querySelector(".subChildDropDown");
    if (subChildDropDownDiv != null) {
      let subChildDropDownChild =
        subChildDropDownDiv.querySelector(".dropdown-menu");
      subChildDropDownChild.classList.remove("show");
      setCharitDown(!charitDown);
    }
  };

  return (
    <>
      <NotificationBar></NotificationBar>
      <Navbar
        className="navbar bgColorHedaer"
        variant="secondary"
        expand="lg"
        sticky="top"
      >
        <Navbar.Brand href="/">
          <img
            data-testid="casebookConnect-logo"
            className="casebookConnect-logo"
            src={logo}
            // src={`${process.env.PUBLIC_URL}/images/CC_branding_New.png`}
            alt="CaseBook Connect Logo"
          />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <div className="ml-auto">
            {!isTabletOrMobile && (
              <>
                {props.pageName === "login" ? (
                  <Nav className="logoutBlockHeader">
                    {/* <DropdownButton
                      id="product"
                      variant="default"
                      className="display-inline-block"
                      title="Products"
                      aria-label="Products"
                      aria-controls="product_menu"
                      menuProps={{
                        id: "product_menu",
                        "aria-labelledby": "product",
                      }}
                    >
                      <Dropdown.Item
                        eventKey="option-1"
                        href="/connectedeBooks"
                      >
                        Connected eBooks
                      </Dropdown.Item>

                      <Dropdown.Item eventKey="option-2" href="/cq">
                        Connected Quizzing
                      </Dropdown.Item>

                      <Dropdown.Item
                        eventKey="option-3"
                        href="/practiceperfect"
                      >
                        PracticePerfect
                      </Dropdown.Item>
                    </DropdownButton> */}
                    {/* fixed navigation through tab a11y_issue */}
                    <Dropdown
                      className="display-inline-block"
                      onKeyDown={handleDropdownTabKey}
                    >
                      <Dropdown.Toggle
                        id="product"
                        variant="default"
                        aria-label="Products"
                        aria-haspopup="true"
                        aria-controls="product_menu"
                      >
                        Products
                      </Dropdown.Toggle>

                      <Dropdown.Menu
                        id="product_menu"
                        aria-labelledby="product"
                      >
                        <Dropdown.Item
                          eventKey="option-1"
                          href="/connectedeBooks"
                        >
                          Connected eBooks
                        </Dropdown.Item>

                        <Dropdown.Item eventKey="option-2" href="/cq">
                          Connected Quizzing
                        </Dropdown.Item>

                        <Dropdown.Item
                          eventKey="option-3"
                          href="/practiceperfect"
                        >
                          PracticePerfect
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                    <Nav.Link eventKey="faculty" href="/faculty">
                      Faculty
                    </Nav.Link>
                    <Nav.Link eventKey="catalog" href="/catalog">
                      Catalog
                    </Nav.Link>
                    <Nav.Link
                      eventKey="helpCenter"
                      href="https://support.aspenpublishing.com/hc/en-us"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Help Center
                    </Nav.Link>
                    <nav className="navbar navbar-dark logoutBlockContainer">
                      <button
                        className="logoutBlockBtn"
                        type="button"
                        href="/login"
                        aria-label="Log In"
                        onClick={() => gotoLogin()}
                      >
                        Log In
                      </button>
                    </nav>
                  </Nav>
                ) : null}
                {props.pageName === "read" ? (
                  <Nav activeKey={props.pageName}>
                    <Nav.Link eventKey="dashboard" href="/">
                      Dashboard
                    </Nav.Link>
                    <Nav.Link
                      eventKey="read"
                      href={window.location.href}
                      aria-label="Ebook"
                    >
                      Read
                    </Nav.Link>
                    {props.bookVO &&
                    props.bookVO.adminStudyFlag &&
                    props.bookVO.adminStudyFlag === "true" ? (
                      userVO?.userRole !== undefined ? (
                        userVO?.userRole === "Professor" ? (
                          <Nav.Link
                            eventKey="study"
                            href={
                              props.bookVO !== undefined
                                ? `${process.env.PUBLIC_URL}/study/` +
                                  props.bookVO.bookISBN
                                : localStorage.getItem("BASE_URL")
                            }
                          >
                            Study
                          </Nav.Link>
                        ) : (
                          <Nav.Link
                            eventKey="study"
                            href={
                              props.bookVO !== undefined
                                ? `${process.env.PUBLIC_URL}/study/` +
                                  props.bookVO.bookISBN +
                                  "/" +
                                  props.bookVO.chapterId
                                : "/study/1234/chapter"
                            }
                          >
                            Study
                          </Nav.Link>
                        )
                      ) : null
                    ) : null}
                    {props.bookVO &&
                    props.bookVO.adminInsightsFlag &&
                    props.bookVO.adminInsightsFlag === "true" ? (
                      <Nav.Link
                        eventKey="Insights"
                        href={
                          props.bookVO !== undefined
                            ? `${process.env.PUBLIC_URL}/insights/` +
                              props.bookVO.bookISBN
                            : localStorage.getItem("BASE_URL")
                        }
                      >
                        Insights
                      </Nav.Link>
                    ) : null}
                    {props.bookVO ? (
                      props.bookVO.resourceVO ? (
                        <Nav.Link
                          eventKey="resources"
                          href={
                            `${process.env.PUBLIC_URL}/resources/` +
                            props.bookVO.resourceVO.resourceISBN
                          }
                        >
                          Resources
                        </Nav.Link>
                      ) : null
                    ) : null}
                  </Nav>
                ) : null}
                {props.pageName === "offlineRead" ? (
                  <Nav activeKey={props.pageName}>
                    <Nav.Link
                      eventKey="offlineRead"
                      href={window.location.href}
                      aria-label="Ebook"
                    >
                      Reading Offline
                    </Nav.Link>
                  </Nav>
                ) : null}
                {props.pageName === "resource" ? (
                  <Nav activeKey={props.pageName}>
                    <Nav.Link eventKey="dashboard" href="/">
                      Dashboard
                    </Nav.Link>
                    {props.bookVO ? (
                      <Nav.Link
                        eventKey="read"
                        href={
                          props.bookVO
                            ? `${process.env.PUBLIC_URL}/read/users/` +
                              userVO?.userId +
                              "/books/" +
                              props.bookVO.bookISBN +
                              "/" +
                              (props.bookVO.lastReadChapterId
                                ? props.bookVO.lastReadPageNum
                                  ? `${props.bookVO.lastReadChapterId}#page-${props.bookVO.lastReadPageNum}`
                                  : props.bookVO.lastReadChapterId
                                : props.bookVO.tocChapterId)
                            : localStorage.getItem("BASE_URL")
                        }
                      >
                        Read
                      </Nav.Link>
                    ) : null}
                    {props.bookVO &&
                    props.bookVO.adminStudyFlag &&
                    props.bookVO.adminStudyFlag === "true" ? (
                      userVO?.userRole ? (
                        userVO?.userRole === "Professor" ? (
                          <Nav.Link
                            eventKey="study"
                            href={
                              props.bookVO !== undefined
                                ? `${process.env.PUBLIC_URL}/study/` +
                                  props.bookVO.bookISBN
                                : localStorage.getItem("BASE_URL")
                            }
                          >
                            Study
                          </Nav.Link>
                        ) : (
                          <Nav.Link
                            eventKey="study"
                            href={
                              props.bookVO !== undefined
                                ? `${process.env.PUBLIC_URL}/study/` +
                                  props.bookVO.bookISBN +
                                  "/" +
                                  props.bookVO.lastReadChapterId
                                : "/study/1234/chapter"
                            }
                          >
                            Study
                          </Nav.Link>
                        )
                      ) : null
                    ) : null}
                    {props.bookVO &&
                    props.bookVO.adminInsightsFlag &&
                    props.bookVO.adminInsightsFlag === "true" ? (
                      <Nav.Link
                        eventKey="Insights"
                        href={
                          props.bookVO !== undefined
                            ? `${process.env.PUBLIC_URL}/insights/` +
                              props.bookVO.bookISBN
                            : localStorage.getItem("BASE_URL")
                        }
                      >
                        Insights
                      </Nav.Link>
                    ) : null}
                    <Nav.Link
                      eventKey="resources"
                      href={window.location.href}
                      className="active"
                    >
                      Resources
                    </Nav.Link>
                  </Nav>
                ) : null}
                {props.pageName === "study" ? (
                  <Nav activeKey={props.pageName}>
                    <Nav.Link eventKey="dashboard" href="/">
                      Dashboard
                    </Nav.Link>
                    <Nav.Link
                      eventKey="read"
                      href={
                        props.bookVO !== null
                          ? `${process.env.PUBLIC_URL}/read/users/` +
                            userVO?.userId +
                            "/books/" +
                            props.bookVO.bookISBN +
                            "/" +
                            (props.bookVO.lastReadChapterId
                              ? props.bookVO.lastReadPageNum
                                ? `${props.bookVO.lastReadChapterId}#page-${props.bookVO.lastReadPageNum}`
                                : props.bookVO.lastReadChapterId
                              : props.bookVO.tocChapterId)
                          : localStorage.getItem("BASE_URL")
                      }
                    >
                      Read
                    </Nav.Link>
                    <Nav.Link eventKey="study" href={window.location.href}>
                      Study
                    </Nav.Link>
                    {props.bookVO &&
                    props.bookVO.adminInsightsFlag &&
                    props.bookVO.adminInsightsFlag === "true" ? (
                      <Nav.Link
                        eventKey="Insights"
                        href={
                          props.bookVO !== undefined
                            ? `${process.env.PUBLIC_URL}/insights/` +
                              props.bookVO.bookISBN
                            : localStorage.getItem("BASE_URL")
                        }
                      >
                        Insights
                      </Nav.Link>
                    ) : null}
                    {props.bookVO ? (
                      props.bookVO.resourceVO ? (
                        <Nav.Link
                          eventKey="resources"
                          href={
                            `${process.env.PUBLIC_URL}/resources/` +
                            props.bookVO.resourceVO.resourceISBN
                          }
                        >
                          Resources
                        </Nav.Link>
                      ) : null
                    ) : null}
                  </Nav>
                ) : null}
                {props.pageName === "insights" ? (
                  <Nav activeKey={props.pageName}>
                    <Nav.Link eventKey="dashboard" href="/">
                      Dashboard
                    </Nav.Link>
                    <Nav.Link
                      eventKey="read"
                      href={
                        props.bookVO !== null
                          ? `${process.env.PUBLIC_URL}/read/users/` +
                            userVO?.userId +
                            "/books/" +
                            props.bookVO.bookISBN +
                            "/" +
                            (props.bookVO.lastReadChapterId
                              ? props.bookVO.lastReadPageNum
                                ? `${props.bookVO.lastReadChapterId}#page-${props.bookVO.lastReadPageNum}`
                                : props.bookVO.lastReadChapterId
                              : props.bookVO.tocChapterId)
                          : localStorage.getItem("BASE_URL")
                      }
                    >
                      Read
                    </Nav.Link>
                    {props.bookVO &&
                    props.bookVO.adminStudyFlag &&
                    props.bookVO.adminStudyFlag === "true" ? (
                      userVO?.userRole !== undefined ? (
                        userVO?.userRole === "Professor" ? (
                          <Nav.Link
                            eventKey="study"
                            href={
                              props.bookVO !== undefined
                                ? `${process.env.PUBLIC_URL}/study/` +
                                  props.bookVO.bookISBN
                                : localStorage.getItem("BASE_URL")
                            }
                          >
                            Study
                          </Nav.Link>
                        ) : (
                          <Nav.Link
                            eventKey="study"
                            href={
                              props.bookVO !== undefined
                                ? `${process.env.PUBLIC_URL}/study/` +
                                  props.bookVO.bookISBN +
                                  "/" +
                                  props.bookVO.chapterId
                                : "/study/1234/chapter"
                            }
                          >
                            Study
                          </Nav.Link>
                        )
                      ) : null
                    ) : null}
                    <Nav.Link eventKey="insights" href={window.location.href}>
                      Insights
                    </Nav.Link>
                    {props.bookVO ? (
                      props.bookVO.resourceVO ? (
                        <Nav.Link
                          eventKey="resources"
                          href={
                            `${process.env.PUBLIC_URL}/resources/` +
                            props.bookVO.resourceVO.resourceISBN
                          }
                        >
                          Resources
                        </Nav.Link>
                      ) : null
                    ) : null}
                  </Nav>
                ) : null}
                {props.pageName === "CQStudent" ||
                props.pageName === "CQProf" ? (
                  <Nav activeKey={props.pageName}>
                    <Nav.Link eventKey="dashboard" href="/">
                      Dashboard
                    </Nav.Link>
                    {userVO?.userRole !== undefined ? (
                      userVO?.userRole === "Student" && isTAUser != "true" ? (
                        <Nav.Link
                          eventKey="CQStudent"
                          href={`${process.env.PUBLIC_URL}/cq-student/`}
                        >
                          Assignments
                        </Nav.Link>
                      ) : userVO?.userRole === "Professor" &&
                        isTAUser != "true" ? (
                        <Nav.Link
                          eventKey="CQProf"
                          href={`${process.env.PUBLIC_URL}/cq-professor/`}
                        >
                          Classes
                        </Nav.Link>
                      ) : null
                    ) : null}
                    {isTAUser == "true" ? (
                      <>
                        <Nav.Link
                          eventKey="CQStudent"
                          href={`${process.env.PUBLIC_URL}/cq-student/`}
                        >
                          Classes Enrolled
                        </Nav.Link>
                        <Nav.Link
                          eventKey="CQProf"
                          href={`${process.env.PUBLIC_URL}/cq-professor/`}
                        >
                          Classes Assisting
                        </Nav.Link>
                      </>
                    ) : null}
                    {userVO?.userRole !== undefined ? (
                      userVO?.userRole === "Student" ? (
                        <Nav.Link
                          eventKey="helpCenter"
                          href="https://support.aspenpublishing.com/hc/en-us"
                          className="profHelpCenter"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Help Center
                        </Nav.Link>
                      ) : userVO?.userRole === "Professor" ? (
                        <>
                          <button
                            type="button"
                            className="cqProfQuizConcBtn btn"
                            onClick={() => setShowConFormPopUp(true)}
                          >
                            Quiz Concierge
                          </button>
                        </>
                      ) : null
                    ) : null}
                  </Nav>
                ) : null}
                {props.pageName === "CCPracticePerfect" ||
                props.pageName === "PPClasses" ||
                props.pageName === "PPVideos" ||
                props.pageName === "PPQuizzes" ||
                props.pageName === "PPProgress" ||
                props.pageName === "PPClassStudentsTopicScores" ||
                props.pageName === "PPClassStudentsDetails" ||
                props.pageName === "PPClassStudentSubTopicPage" ? (
                  <Nav activeKey={props.pageName}>
                    <Nav.Link eventKey="dashboard" href="/">
                      Dashboard
                    </Nav.Link>
                    {userVO?.userRole !== undefined ? (
                      <>
                        {userVO?.userRole === "Professor" &&
                        isTAUser !== "true" ? (
                          <Nav.Link
                            eventKey="PPClasses"
                            href={`${process.env.PUBLIC_URL}/pp-classes/${props.isbn}`}
                          >
                            Classes
                          </Nav.Link>
                        ) : null}
                        <Nav.Link
                          eventKey="PPVideos"
                          href={`${process.env.PUBLIC_URL}/pp-video-library/${props.isbn}`}
                        >
                          Videos
                        </Nav.Link>
                        <Nav.Link
                          eventKey="PPQuizzes"
                          href={`${process.env.PUBLIC_URL}/pp-quiz-center/${props.isbn}`}
                        >
                          Quizzes
                        </Nav.Link>
                        <Nav.Link
                          eventKey="PPProgress"
                          href={`${process.env.PUBLIC_URL}/pp-progress/${props.isbn}`}
                        >
                          Progress
                        </Nav.Link>
                      </>
                    ) : null}
                  </Nav>
                ) : null}
              </>
            )}
          </div>
        </Navbar.Collapse>
        <div className="display-inline-block headerMenuNavBlock">
          {props.pageName !== "login" && props.pageName !== "offlineRead" ? (
            <>
              {/* fixed navigation through tab a11y_issue: aria-controls landed on the
                  wrapper div, not the toggle. Original below. */}
              {/* <DropdownButton
                variant="default"
                menuAlign="right"
                label="Menu"
                aria-label="Menu"
                // label="More Options"
                aria-controls="menu-dropdown"
                className="display-inline-block faBarsMenuBlock"
                onKeyDown={handleDropdownTabKey}
                title={
                  <FaBars
                    data-testid="menu"
                    // aria-label="productsMenu"
                    aria-hidden="true"
                    className="faBarsMenuSec"
                    onClick={handleOnBlurEvent}
                  />
                }
              > */}
              <Dropdown
                className="display-inline-block faBarsMenuBlock"
                // fixed navigation through tab a11y_issue
                onKeyDown={handleDropdownTabKey}
              >
                <Dropdown.Toggle
                  id="menu-button"
                  variant="default"
                  aria-label="Menu"
                  aria-controls="menu-dropdown"
                >
                  <FaBars
                    data-testid="menu"
                    aria-hidden="true"
                    className="faBarsMenuSec"
                    onClick={handleOnBlurEvent}
                  />
                </Dropdown.Toggle>
                <Dropdown.Menu
                  id="menu-dropdown"
                  align="right"
                  aria-labelledby="menu-button"
                >
                {/* fixed navigation through tab a11y_issue: wrapping <a> made a second,
                    unstyled tab stop per row. Original below. */}
                {/* <a href="/">
                  <Dropdown.Item as="button" eventKey="option-1">
                    Home
                  </Dropdown.Item>
                </a> */}
                {/* fixed navigation through tab a11y_issue */}
                <Dropdown.Item href="/" eventKey="option-1">
                  Home
                </Dropdown.Item>
                <DropdownSubmenu
                  className="subChildDropDown"
                  href="#action/3.7"
                  title={
                    /* fixed navigation through tab a11y_issue: was an <a> nested inside the
                       row anchor, giving a second tab stop; <span> keeps it to one. */
                    <span
                      id={productsSubmenuButtonId}
                      className="display-inline-block subChildDropDownParent"
                      aria-haspopup="true"
                      aria-expanded={charitDown}
                      aria-controls={productsSubmenuId}
                      onClick={(e) => {
                        e.preventDefault();
                        setCharitDown((prev) => !prev);
                      }}
                    >
                      Products
                      {charitDown ? (
                        <AiFillCaretDown
                          aria-hidden="true"
                          className="AiFillCaretPosition AiFillCaretDown pull-right"
                        />
                      ) : (
                        <AiFillCaretRight
                          aria-hidden="true"
                          className="AiFillCaretRight AiFillCaretPosition pull-right"
                        />
                      )}
                    </span>
                  }
                >
                  <ul
                    id={productsSubmenuId}
                    aria-describedby={productsSubmenuButtonId}
                    style={{
                      listStyleType: "none",
                      paddingLeft: 0,
                      marginBottom: 0,
                    }}
                  >
                    <li>
                      <Dropdown.Item href="/connectedeBooks">
                        Connected eBooks
                      </Dropdown.Item>
                    </li>
                    <li>
                      <Dropdown.Item href="/cq">
                        Connected Quizzing
                      </Dropdown.Item>
                    </li>
                    <li>
                      <Dropdown.Item href="/practiceperfect">
                        PracticePerfect
                      </Dropdown.Item>
                    </li>
                  </ul>
                </DropdownSubmenu>
                {/* fixed navigation through tab a11y_issue: same double tab stop as above.
                    Originals below. */}
                {/* <a href="/faculty">
                  <Dropdown.Item as="button" eventKey="option-2">
                    Faculty
                  </Dropdown.Item>
                </a>
                <a href="/catalog">
                  <Dropdown.Item as="button" eventKey="option-3">
                    Catalog
                  </Dropdown.Item>
                </a>
                <a href="https://support.aspenpublishing.com/hc/en-us">
                  <Dropdown.Item
                    as="button"
                    eventKey="option-4"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Help Center
                  </Dropdown.Item>
                </a> */}
                {/* fixed navigation through tab a11y_issue */}
                <Dropdown.Item href="/faculty" eventKey="option-2">
                  Faculty
                </Dropdown.Item>
                {/* fixed navigation through tab a11y_issue */}
                <Dropdown.Item href="/catalog" eventKey="option-3">
                  Catalog
                </Dropdown.Item>
                {/* fixed navigation through tab a11y_issue */}
                <Dropdown.Item
                  href="https://support.aspenpublishing.com/hc/en-us"
                  eventKey="option-4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Help Center
                </Dropdown.Item>
                {((isTabletOrMobileDevice && isTabletOrMobile) ||
                  (isDesktopOrLaptop && isTabletOrMobile)) && (
                  <>
                    <hr />
                    {props.pageName === "read" ? (
                      <Nav
                        activeKey={props.pageName}
                        onSelect={(k) => setKey(k)}
                      >
                        <Nav.Link eventKey="dashboard" href="/">
                          Dashboard
                        </Nav.Link>
                        <Nav.Link
                          eventKey="read"
                          href={window.location.href}
                          aria-label="Ebook"
                        >
                          Read
                        </Nav.Link>
                        {userVO?.userRole &&
                        props.bookVO &&
                        props.bookVO.adminStudyFlag &&
                        props.bookVO.adminStudyFlag === "true" ? (
                          userVO?.userRole === "Professor" ? (
                            <Nav.Link
                              eventKey="study"
                              href={
                                props.bookVO !== undefined
                                  ? `${process.env.PUBLIC_URL}/study/` +
                                    props.bookVO.bookISBN
                                  : localStorage.getItem("BASE_URL")
                              }
                            >
                              Study
                            </Nav.Link>
                          ) : (
                            <Nav.Link
                              eventKey="study"
                              href={
                                props.bookVO !== undefined
                                  ? `${process.env.PUBLIC_URL}/study/` +
                                    props.bookVO.bookISBN +
                                    "/" +
                                    props.bookVO.chapterId
                                  : "/study/1234/chapter"
                              }
                            >
                              Study
                            </Nav.Link>
                          )
                        ) : null}
                        {props.bookVO &&
                        props.bookVO.adminStudyFlag &&
                        props.bookVO.adminStudyFlag === "true" ? (
                          <Nav.Link
                            eventKey="Insights"
                            href={
                              props.bookVO !== undefined
                                ? `${process.env.PUBLIC_URL}/insights/` +
                                  props.bookVO.bookISBN
                                : localStorage.getItem("BASE_URL")
                            }
                          >
                            Insights
                          </Nav.Link>
                        ) : null}
                        {props.bookVO ? (
                          props.bookVO.resourceVO ? (
                            <Nav.Link
                              eventKey="resources"
                              href={
                                `${process.env.PUBLIC_URL}/resources/` +
                                props.bookVO.resourceVO.resourceISBN
                              }
                            >
                              Resources
                            </Nav.Link>
                          ) : null
                        ) : null}
                      </Nav>
                    ) : null}
                    {props.pageName === "resource" ? (
                      <Nav
                        activeKey={props.pageName}
                        onSelect={(k) => setKey(k)}
                      >
                        <Nav.Link eventKey="dashboard" href="/">
                          Dashboard
                        </Nav.Link>
                        <Nav.Link
                          eventKey="read"
                          href={
                            props.bookVO !== null && props.bookVO !== undefined
                              ? `${process.env.PUBLIC_URL}/read/users/` +
                                userVO?.userId +
                                "/books/" +
                                props.bookVO.bookISBN +
                                "/" +
                                (props.bookVO.lastReadChapterId
                                  ? props.bookVO.lastReadPageNum
                                    ? `${props.bookVO.lastReadChapterId}#page-${props.bookVO.lastReadPageNum}`
                                    : props.bookVO.lastReadChapterId
                                  : props.bookVO.tocChapterId)
                              : localStorage.getItem("BASE_URL")
                          }
                        >
                          Read
                        </Nav.Link>
                        {props.bookVO &&
                        props.bookVO.adminStudyFlag &&
                        props.bookVO.adminStudyFlag === "true" ? (
                          userVO?.userRole !== undefined ? (
                            userVO?.userRole === "Professor" ? (
                              <Nav.Link
                                eventKey="study"
                                href={
                                  props.bookVO !== undefined
                                    ? `${process.env.PUBLIC_URL}/study/` +
                                      props.bookVO.bookISBN
                                    : localStorage.getItem("BASE_URL")
                                }
                              >
                                Study
                              </Nav.Link>
                            ) : (
                              <Nav.Link
                                eventKey="study"
                                href={
                                  props.bookVO !== undefined
                                    ? `${process.env.PUBLIC_URL}/study/` +
                                      props.bookVO.bookISBN +
                                      "/" +
                                      props.bookVO.chapterId
                                    : "/study/1234/chapter"
                                }
                              >
                                Study
                              </Nav.Link>
                            )
                          ) : null
                        ) : null}
                        {props.bookVO &&
                        props.bookVO.adminStudyFlag &&
                        props.bookVO.adminStudyFlag === "true" ? (
                          <Nav.Link
                            eventKey="Insights"
                            href={
                              props.bookVO !== null
                                ? `${process.env.PUBLIC_URL}/insights/` +
                                  props.bookVO.bookISBN
                                : localStorage.getItem("BASE_URL")
                            }
                          >
                            Insights
                          </Nav.Link>
                        ) : null}
                        <Nav.Link
                          eventKey="resources"
                          href={window.location.href}
                          className="active"
                        >
                          Resources
                        </Nav.Link>
                      </Nav>
                    ) : null}
                    {props.pageName === "study" ? (
                      <Nav
                        activeKey={props.pageName}
                        onSelect={(k) => setKey(k)}
                      >
                        <Nav.Link eventKey="dashboard" href="/">
                          Dashboard
                        </Nav.Link>
                        <Nav.Link
                          eventKey="read"
                          href={
                            props.bookVO !== null
                              ? `${process.env.PUBLIC_URL}/read/users/` +
                                userVO?.userId +
                                "/books/" +
                                props.bookVO.bookISBN +
                                "/" +
                                (props.bookVO.lastReadChapterId
                                  ? props.bookVO.lastReadPageNum
                                    ? `${props.bookVO.lastReadChapterId}#page-${props.bookVO.lastReadPageNum}`
                                    : props.bookVO.lastReadChapterId
                                  : props.bookVO.tocChapterId)
                              : localStorage.getItem("BASE_URL")
                          }
                        >
                          Read
                        </Nav.Link>
                        <Nav.Link eventKey="study" href={window.location.href}>
                          Study
                        </Nav.Link>
                        {props.bookVO &&
                        props.bookVO.adminStudyFlag &&
                        props.bookVO.adminStudyFlag === "true" ? (
                          <Nav.Link
                            eventKey="Insights"
                            href={
                              props.bookVO !== null
                                ? `${process.env.PUBLIC_URL}/insights/` +
                                  props.bookVO.bookISBN
                                : localStorage.getItem("BASE_URL")
                            }
                          >
                            Insights
                          </Nav.Link>
                        ) : null}
                        {props.bookVO ? (
                          props.bookVO.resourceVO ? (
                            <Nav.Link
                              eventKey="resources"
                              href={
                                `${process.env.PUBLIC_URL}/resources/` +
                                props.bookVO.resourceVO.resourceISBN
                              }
                            >
                              Resources
                            </Nav.Link>
                          ) : null
                        ) : null}
                      </Nav>
                    ) : null}
                    {props.pageName === "insights" ? (
                      <Nav
                        activeKey={props.pageName}
                        onSelect={(k) => setKey(k)}
                      >
                        <Nav.Link eventKey="dashboard" href="/">
                          Dashboard
                        </Nav.Link>
                        <Nav.Link
                          eventKey="read"
                          href={
                            props.bookVO !== null
                              ? `${process.env.PUBLIC_URL}/read/users/` +
                                userVO?.userId +
                                "/books/" +
                                props.bookVO.bookISBN +
                                "/" +
                                (props.bookVO.lastReadChapterId
                                  ? props.bookVO.lastReadPageNum
                                    ? `${props.bookVO.lastReadChapterId}#page-${props.bookVO.lastReadPageNum}`
                                    : props.bookVO.lastReadChapterId
                                  : props.bookVO.tocChapterId)
                              : localStorage.getItem("BASE_URL")
                          }
                        >
                          Read
                        </Nav.Link>
                        {props.bookVO &&
                        props.bookVO.adminStudyFlag &&
                        props.bookVO.adminStudyFlag === "true" ? (
                          userVO?.userRole !== undefined ? (
                            userVO?.userRole === "Professor" ? (
                              <Nav.Link
                                eventKey="study"
                                href={
                                  props.bookVO !== undefined
                                    ? `${process.env.PUBLIC_URL}/study/` +
                                      props.bookVO.bookISBN
                                    : localStorage.getItem("BASE_URL")
                                }
                              >
                                Study
                              </Nav.Link>
                            ) : (
                              <Nav.Link
                                eventKey="study"
                                href={
                                  props.bookVO !== undefined
                                    ? `${process.env.PUBLIC_URL}/study/` +
                                      props.bookVO.bookISBN +
                                      "/" +
                                      props.bookVO.chapterId
                                    : "/study/1234/chapter"
                                }
                              >
                                Study
                              </Nav.Link>
                            )
                          ) : null
                        ) : null}
                        <Nav.Link
                          eventKey="insights"
                          href={window.location.href}
                        >
                          Insights
                        </Nav.Link>
                        {props.bookVO ? (
                          props.bookVO.resourceVO ? (
                            <Nav.Link
                              eventKey="resources"
                              href={
                                `${process.env.PUBLIC_URL}/resources/` +
                                props.bookVO.resourceVO.resourceISBN
                              }
                            >
                              Resources
                            </Nav.Link>
                          ) : null
                        ) : null}
                      </Nav>
                    ) : null}
                    {props.pageName === "CQStudent" ||
                    props.pageName === "CQProf" ? (
                      <Nav activeKey={props.pageName}>
                        <Nav.Link eventKey="dashboard" href="/">
                          Dashboard
                        </Nav.Link>
                        {userVO?.userRole !== undefined ? (
                          userVO?.userRole === "Student" &&
                          isTAUser != "true" ? (
                            <Nav.Link
                              eventKey="CQStudent"
                              href={`${process.env.PUBLIC_URL}/cq-student/`}
                            >
                              Assignments
                            </Nav.Link>
                          ) : userVO?.userRole === "Professor" &&
                            isTAUser != "true" ? (
                            <Nav.Link
                              eventKey="CQProf"
                              href={`${process.env.PUBLIC_URL}/cq-professor/`}
                            >
                              Classes
                            </Nav.Link>
                          ) : null
                        ) : null}
                        {isTAUser == "true" ? (
                          <>
                            <Nav.Link
                              eventKey="CQStudent"
                              href={`${process.env.PUBLIC_URL}/cq-student/`}
                            >
                              Classes Enrolled
                            </Nav.Link>
                            <Nav.Link
                              eventKey="CQProf"
                              href={`${process.env.PUBLIC_URL}/cq-professor/`}
                            >
                              Classes Assisting
                            </Nav.Link>
                          </>
                        ) : null}
                        {userVO?.userRole !== undefined ? (
                          userVO?.userRole === "Student" ? (
                            <Nav.Link
                              eventKey="helpCenter"
                              href="https://support.aspenpublishing.com/hc/en-us"
                              className="profHelpCenter"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Help Center
                            </Nav.Link>
                          ) : userVO?.userRole === "Professor" ? (
                            <>
                              <button
                                type="button"
                                className="cqProfQuizConcBtn btn"
                                onClick={() => setShowConFormPopUp(true)}
                              >
                                Quiz Concierge
                              </button>
                            </>
                          ) : null
                        ) : null}
                      </Nav>
                    ) : null}
                    {props.pageName === "CCPracticePerfect" ||
                    props.pageName === "PPClasses" ||
                    props.pageName === "PPVideos" ||
                    props.pageName === "PPQuizzes" ||
                    props.pageName === "PPProgress" ||
                    props.pageName === "PPClassStudentsTopicScores" ||
                    props.pageName === "PPClassStudentsDetails" ||
                    props.pageName === "PPClassStudentSubTopicPage" ? (
                      <Nav activeKey={props.pageName}>
                        <Nav.Link eventKey="dashboard" href="/">
                          Dashboard
                        </Nav.Link>
                        {userVO?.userRole !== undefined ? (
                          <>
                            {userVO?.userRole === "Professor" &&
                            isTAUser !== "true" ? (
                              <Nav.Link
                                eventKey="PPClasses"
                                href={`${process.env.PUBLIC_URL}/pp-classes/${props.isbn}`}
                              >
                                Classes
                              </Nav.Link>
                            ) : null}
                            <Nav.Link
                              eventKey="PPVideos"
                              role="main"
                              href={`${process.env.PUBLIC_URL}/pp-video-library/${props.isbn}`}
                            >
                              Videos
                            </Nav.Link>
                            <Nav.Link
                              eventKey="PPQuizzes"
                              role="main"
                              href={`${process.env.PUBLIC_URL}/pp-quiz-center/${props.isbn}`}
                            >
                              Quizzes
                            </Nav.Link>
                            <Nav.Link
                              eventKey="PPProgress"
                              role="main"
                              href={`${process.env.PUBLIC_URL}/pp-progress/${props.isbn}`}
                            >
                              Progress
                            </Nav.Link>
                          </>
                        ) : null}
                      </Nav>
                    ) : null}
                  </>
                )}
                {/* fixed navigation through tab a11y_issue */}
                </Dropdown.Menu>
              </Dropdown>

              {/* User Account Dropdown */}
              {/* fixed navigation through tab a11y_issue: react-bootstrap 1.5.1 has no
                  `menuProps`, so the menu never got its id/aria-labelledby. Original below. */}
              {/* <DropdownButton
                // id="my-account-dropdown-menu"
                id="account-button"
                aria-label="Account"
                aria-controls="account-menu"
                menuAlign="right"
                variant="default"
                label="Account"
                className="display-inline-block faBarsMenuBlock"
                onKeyDown={handleDropdownTabKey}
                menuProps={{
                  id: "account-menu",
                  "aria-labelledby": "account-button",
                }}
                title={
                  <>
                    <span className="sr-only">Account</span>
                    <FaUserAlt
                      data-testid="account"
                      aria-hidden="true"
                      className="faBarsMenuSec"
                    />
                  </>
                }
              > */}
              <Dropdown
                className="display-inline-block faBarsMenuBlock"
                // fixed navigation through tab a11y_issue
                onKeyDown={handleDropdownTabKey}
              >
                <Dropdown.Toggle
                  id="account-button"
                  variant="default"
                  aria-label="Account"
                  aria-controls="account-menu"
                >
                  <span className="sr-only">Account</span>
                  <FaUserAlt
                    data-testid="account"
                    aria-hidden="true"
                    className="faBarsMenuSec"
                  />
                </Dropdown.Toggle>
                <Dropdown.Menu
                  id="account-menu"
                  align="right"
                  aria-labelledby="account-button"
                >
                <Dropdown.Item
                  as="button"
                  eventKey="option-1"
                  onClick={() => setRedeemAccesCode(true)}
                >
                  Redeem an Access Code
                </Dropdown.Item>

                {/* 45139 - My Account Link Not Always Working: original block commented out - `as="button"` made React-Bootstrap render a <button href="/myAccount">, and browsers ignore href on a button, so the item never navigated */}
                {/* <Dropdown.Item
                  href="/myAccount"
                  as="button"
                  eventKey="option-2"
                >
                  My Account
                </Dropdown.Item> */}
                {/* 45139 - My Account Link Not Always Working: dropped `as="button"` so the item renders via SafeAnchor as a real <a href="/myAccount">, restoring the full-page navigation to the legacy My Account page */}
                <Dropdown.Item href="/myAccount" eventKey="option-2">
                  My Account
                </Dropdown.Item>
                <Dropdown.Item
                  as="button"
                  eventKey="option-4"
                  onClick={() => handleShowTutorialPopup()}
                >
                  Tutorial
                </Dropdown.Item>
                <Dropdown.Item
                  as="button"
                  eventKey="option-3"
                  onClick={() => handleLogOut()}
                >
                  Logout
                </Dropdown.Item>
                {/* fixed navigation through tab a11y_issue */}
                </Dropdown.Menu>
              </Dropdown>
            </>
          ) : null}
          {/* Dropdown menu */}
          {(isTabletOrMobileDevice && isTabletOrMobile) ||
          (isDesktopOrLaptop && isTabletOrMobile)
            ? props.pageName !== "login" &&
              props.pageName === "offlineRead" && (
                /* fixed navigation through tab a11y_issue: same inert aria-controls as above.
                   Original:
                   <DropdownButton
                     variant="default"
                     menuAlign="right"
                     aria-controls="menu-dropdown"
                     label="Menu"
                     aria-label="Menu"
                     className="display-inline-block faBarsMenuBlock"
                     onKeyDown={handleDropdownTabKey}
                     title={<FaBars aria-hidden="true" className="faBarsMenuSec" />}
                   > */
                <Dropdown
                  className="display-inline-block faBarsMenuBlock"
                  // fixed navigation through tab a11y_issue
                  onKeyDown={handleDropdownTabKey}
                >
                  <Dropdown.Toggle
                    id="offline-menu-button"
                    variant="default"
                    aria-label="Menu"
                    aria-controls="offline-menu-dropdown"
                  >
                    <FaBars aria-hidden="true" className="faBarsMenuSec" />
                  </Dropdown.Toggle>
                  <Dropdown.Menu
                    id="offline-menu-dropdown"
                    align="right"
                    aria-labelledby="offline-menu-button"
                  >
                    <hr />
                    <Nav activeKey={props.pageName} onSelect={(k) => setKey(k)}>
                      <Nav.Link
                        eventKey="offlineRead"
                        href={window.location.href}
                        aria-label="Ebook"
                      >
                        Reading Offline
                      </Nav.Link>
                    </Nav>
                  </Dropdown.Menu>
                </Dropdown>
              )
            : null}
        </div>
      </Navbar>

      {/* Redeem Access Code Modal */}
      {/*
        FIX (CriticalCompatible-005_F11):
        - aria-labelledby on <Modal> points to the visible title element's id,
          so React Bootstrap renders aria-labelledby on the role="dialog" node.
        - Removed the duplicate nested <Modal.Header /> that was creating a
          second close button and broken DOM structure.
        - closeLabel gives the close button a descriptive accessible name
          instead of the default "×".
      */}
      <Modal
        className="modal fade"
        show={redeemAccesCode}
        onHide={() => handleHideRedeemAccessCode()}
        id="redeemAccessCodeModalId"
        tabIndex="-1"
        aria-labelledby="redeemAccessLabelId"
      >
        <Modal.Header closeButton closeLabel="Close dialog">
          <h5 className="modal-title" id="redeemAccessLabelId">
            Redeem an Access Code
          </h5>
        </Modal.Header>
        {redeemCodeErr ? (
          <span className="popoverError-label">{redeemCodeErr}</span>
        ) : null}
        <div className="modal-body">
          <div>
            Add a product to your bookshelf by entering your access code below.
          </div>
          <div className="redeemInputBox mTopTen">
            <input
              data-testid="redeemCode"
              type="text"
              name="redeemCode"
              aria-label="Enter access code"
              autoComplete="off"
              style={{ borderRight: "0" }}
              className="accessCodeTxtbox headerRedeemCode acTextBox ember-view ember-text-field form-control text-box-common"
              value={redeemCode}
              onChange={(e) => setRedeemCode(e.target.value)}
              onKeyPress={(e) => handleAccessCodeKeyPress(e)}
            ></input>
            <span className="input-group-btn">
              <button
                type="button"
                title="redeem"
                className="redeemButton"
                onClick={handleRedeemAccessCode}
              >
                Redeem
              </button>
            </span>
          </div>
        </div>
      </Modal>

      {/* Tutorial Modal */}

      <Modal
        size="lg"
        contentClassName="p-4"
        centered
        show={isShowTutorialPopup}
        onHide={() => setIsShowTutorialPopup(false)}
        id="tutorialVideoModalId"
        aria-labelledby="tutorial-modal-title"
      >
        <Modal.Header closeButton closeLabel="Close dialog">
          <Modal.Title className="tutorialPopupTitle" id="tutorial-modal-title">
            {showTutorialPopup.popupHeading}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">
          <p className="tutorialPopupTxt mb-2" id="tutorial-modal-desc">
            {showTutorialPopup.popupDescr}
          </p>
          <div className="modal-content" id="tutorialPopupContentId">
            <div className="tutorialPopupContentDiv">
              <iframe
                id="iframeid"
                title="video"
                src={showTutorialPopup.popupVideoUrl}
                allowFullScreen
                allow="encrypted-media"
                className="iframe-video"
              />
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* Quiz Concierge Contact Form Modal */}

      <Modal
        className="modal fade"
        show={showConFormPopUp}
        onHide={() => handleHideContactMe()}
        size="lg"
        aria-labelledby="quiz-concierge-form-title"
        centered
        dialogClassName="main-modals p-xl-5 p-lg-5 p-md-5 p-sm-0 p-0"
      >
        <div className="cqProfQuizConcPopUp">
          <Modal.Header closeButton closeLabel="Close dialog">
            <Modal.Title
              id="quiz-concierge-form-title"
              role="heading"
              aria-level="2"
              className="cqProfQuizConcPopUpHeader m-auto"
            >
              Speak with the quiz concierge
            </Modal.Title>
          </Modal.Header>
          <div className="pl-4 pr-4 p-0">
            <div className="cqProfQuizConcPopUpBodyTxt pb-3">
              The Quiz Concierge can help you customize your quizzes, set up
              your classes for the semester, and more. <br />
              <br />
              Please provide your contact information and details about your
              request so we can better assist you. You'll be contacted within
              one business day. Alternatively, contact the Quiz Concierge at{" "}
              <a
                href="mailto:concierge@aspenpublishing.com"
                className="cqProfQuizConcPopUpBodyMail"
              >
                concierge@aspenpublishing.com
              </a>{" "}
              with your request.
            </div>
            <div className="row">
              <div className="col">
                <div
                  className="display-inline-block cqProfQuizConcPopUpContInfo"
                  style={{ width: "100%" }}
                >
                  An asterisk (*) indicates a required field
                </div>
                <div className="display-inline-block cqProfQuizConcPopUpContInfo">
                  Contact Information:
                </div>
                <div className="phoneEmailSection">
                  <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 display-inline-block p-0 mt-1">
                    <label
                      htmlFor="cqProfQuizP"
                      className="cqProfQuizConcPopUpPhoneLabel cqProfQuizConcPopUpContLabel d-xl-block d-lg-block d-md-block d-inline-block"
                    >
                      Enter Phone Number *
                    </label>
                    <div className="d-xl-block d-lg-block d-md-block d-inline-block ml-xl-0 ml-lg-0 ml-md-0 ml-3">
                      <input
                        data-testid="phone"
                        aria-describedby="cqPhoneErrMsg"
                        ref={cqProfQuizConcPopUpPhoneInputRef}
                        id="cqProfQuizP"
                        type="text"
                        className="cqProfQuizConcPopUpPhoneInput cqProfQuizConcPopUpContInput rounded-0"
                        name="tel"
                        autoComplete="tel"
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                      />
                    </div>
                    <div>
                      <span
                        id="cqPhoneErrMsg"
                        className="cqProfQuizConcPopUpContErrorMsg"
                      >
                        {phoneErrMsg}
                      </span>
                    </div>
                  </div>
                  <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 display-inline-block pr-0 pl-xl-3 pl-lg-3 pl-md-3 pl-0 mt-xl-1 mt-lg-1 mt-md-2 mt-2">
                    <label
                      htmlFor="cqProfQuizE"
                      className="cqProfQuizConcPopUpEmailLabel cqProfQuizConcPopUpContLabel d-xl-block d-lg-block d-md-block d-inline-block mr-1"
                    >
                      Enter Email Address *
                    </label>
                    <div className="d-xl-block d-lg-block d-md-block d-inline-block ml-xl-0 ml-lg-0 ml-md-0 ml-3">
                      <input
                        data-testid="email"
                        aria-describedby="cqEmailErrMsg"
                        id="cqProfQuizE"
                        type="text"
                        className="cqProfQuizConcPopUpEmailInput cqProfQuizConcPopUpContInput rounded-0"
                        name="email"
                        autoComplete="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </div>
                    <div>
                      <span
                        id="cqEmailErrMsg"
                        className="cqProfQuizConcPopUpContErrorMsg"
                      >
                        {emailErroMsg}
                      </span>
                    </div>
                  </div>
                </div>
                <label
                  htmlFor="cqProfQuizW"
                  className="cqProfQuizConcPopUpContInfo mt-4"
                >
                  What can we do for you?
                </label>
                <input
                  data-testid="message"
                  id="cqProfQuizW"
                  type="text"
                  className="cqProfQuizConcPopUpContMsg rounded-0"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                />
              </div>
            </div>
          </div>
          <div className="pb-0 mt-4">
            <div className="cqProfQuizConcPopUpBtnSec">
              <button
                type="button"
                className="btn btn-md btn-primary cqProfQuizConcPopUpBtn"
                onClick={handleContactMe}
              >
                Contact Me
              </button>
            </div>
          </div>
        </div>
      </Modal>

      {/* Quiz Concierge Thank You Modal */}

      <Modal
        className="modal fade"
        show={showConThanksPopUp}
        onHide={() => setShowConThanksPopUp(false)}
        size="lg"
        aria-labelledby="quiz-concierge-thanks-title"
        centered
        dialogClassName="main-modals p-xl-5 p-lg-5 p-md-5 p-sm-0 p-0"
      >
        <div className="cqProfQuizConcPopUp">
          <Modal.Header closeButton closeLabel="Close dialog">
            <Modal.Title
              id="quiz-concierge-thanks-title"
              role="heading"
              aria-level="2"
              className="cqProfQuizConcPopUpHeader m-auto"
            >
              Speak with the quiz concierge
            </Modal.Title>
          </Modal.Header>
          <div className="cqpProfQuizConcPopUpThankCont">
            <p className="cqProfQuizConcPopUpBodyTxt">Thank you!</p>
            <div className="cqProfQuizConcPopUpBodyTxt">
              Your information has been received and the quiz concierge will
              contact you within one business day.
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
}
